import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "popoverTitle", "popoverTitleId", "children", "onClose", "className", "closeButtonAriaLabel", "closeButtonRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, deprecatedOverlayDirections } from "../../styles/index.mjs";
import { IconX } from "../Icon/icons/IconX/index.mjs";
import { CloseButton } from "./CloseButton.mjs";
import { Popover as PopoverElement } from "./Popover.mjs";
import { Title } from "./Title.mjs";
var PopoverComponent = /*#__PURE__*/React.forwardRef(function PopoverComponent(_ref, ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    popoverTitle = _ref.popoverTitle,
    popoverTitleId = _ref.popoverTitleId,
    children = _ref.children,
    onClose = _ref.onClose,
    className = _ref.className,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Close' : _ref$closeButtonAriaL,
    closeButtonRef = _ref.closeButtonRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PopoverElement, Object.assign({
    ref: ref,
    role: "dialog",
    "aria-labelledby": popoverTitleId,
    paddedBody: !!(onClose && !popoverTitle),
    className: addColorSet(colorSet, className),
    colorSet: colorSet
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Popover
  }), popoverTitle && /*#__PURE__*/React.createElement(Title, {
    id: popoverTitleId
  }, popoverTitle), children, onClose && /*#__PURE__*/React.createElement(CloseButton, {
    ref: closeButtonRef,
    onClick: onClose,
    "aria-label": closeButtonAriaLabel,
    type: "button",
    iconOnly: IconX
  }));
});
var popoverHelpers = _objectSpread({}, deprecatedOverlayDirections);

/**
* **Popover** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Popover) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=291:1143)
*
* A modal used to display some contextual information on top of other content when users click on, keypress on, or touch an element.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/popover?format=figma-figma#popover)
*
* @example
* () => (
*  <Popover arrow="topStart" popoverTitle='Popover "topStart"' onClose={() => {}}>
*    This is a popover with text and its arrow is aligned to the topStart
*  </Popover>
*);
*
*/
export var Popover = Object.assign(PopoverComponent, popoverHelpers);